module.exports = __webpack_public_path__ + "img/c06_unitroyalguard_Normal_ua.162f6523.webp";